import React from 'react'
import { useEffect, useState, useCallback, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import { SelectPicker, Loader } from 'rsuite';
import axios from "axios";
import { DateTime } from 'luxon';
import ToasterNotification from '../../utilities/ToasterNotification';

export default function TimeZoneList({
    // initialTimezone,
    setOptionSelected,
    optionSelected,
    timeZone,
    setTimeZone,
    setToastMsg = ()=>{},
    setShowToast = ()=>{},
    target,
    setH = () => {},
    setBrowserTimezone =() => {}
}) {
    const {
        control,
        register,
        setValue,
    } = useForm()

    const { t } = useTranslation();


    const [timeZoneData, setTimeZoneData] = useState([])
    const [loading, setLoading] = useState(false);
    const [skip, setSkip] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [initialData, setInitialData] = useState([]);
    const [totalRecords,setTotalRecords]=useState(0)
    const isFetched = useRef(false);
    const isLocalTimeZoneFetched = useRef(false);
    const [payload, setPayload] = useState({
        skip: 0,
        limit: 50,
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const getLocalTimeZone = async () => {
            if (isLocalTimeZoneFetched.current) return;
            isLocalTimeZoneFetched.current = true;
            const now = DateTime.now();
            const zoneName = now.zoneName;
            const offset = now.toFormat("ZZ");
            try {
              const response = await axios.get(
                `${globalThis.location.origin}/jsv4/webapi/getLocalTimeZone`,
                {
                  params: { zoneName, offset },
                }
              );
              if (response?.data) {
                setTimeZoneData((prev) => [response?.data, ...prev]);
                setTimeZone(response?.data?.timezoneName)
                setBrowserTimezone(response?.data?.timezoneName)
              }
            } catch (error) {
              console.log("Error fetching Local timezone data:", error);
            } finally {
                setIsLoading(true);
            }
        };
        getLocalTimeZone();
    }, []);

    useEffect(() => {
        const getTimeZoneList = async () => {
            if (isFetched.current) return;
            isFetched.current = true;
            try {
                const response  = await axios.post(`${globalThis.location.origin}/jsv4/webapi/getTimeZoneList`, payload);
                setTimeZoneData((prev) => [ ...prev,...response?.data?.result ]); 
                setInitialData(response?.data?.result || []);
                setTotalRecords(response?.data?.total)
            } catch (error) {
                console.log("Error fetching timezone data:", error);
            }
        };
        if(isLoading){
            getTimeZoneList();
            setIsLoading(false);
        }
    }, [isLoading]);

    const isFetchingMore = useRef(false);
    const searchTermRef = useRef("");

    const handleSearch = async (text) => {
        if (text === searchTermRef.current) { return }
        setSearchTerm(text);
        searchTermRef.current = text;
        if (!text) {
            setTimeZoneData(initialData);
            setSkip(0);
            await loadMore("load");
            return;
        }
        await loadMore(text ? "search" : "load", text);
    };

    const loadMore = async (targeted = "load", currentSearchTerm = "") => {
        if (loading || isFetchingMore.current) return;
        setLoading(true);
        isFetchingMore.current = true;

        try {
            const newStart = targeted === "search" ? 0 : Math.min(skip + 50, totalRecords);
           const updatedPayload = {
                ...(currentSearchTerm ? { search: currentSearchTerm.trim() } : {}),
                ...(targeted==="search"?{}:{limit: 50,skip: newStart}),
            };
            setPayload(updatedPayload);
            const response = await axios.post(`${window.location.origin}/jsv4/webapi/getTimeZoneList`, updatedPayload);
            const timezonedata = Array.isArray(response?.data?.result) ? response?.data?.result : [];

            setTimeZoneData((prevData) => {
                const updatedData = targeted === "search" ? [] : [...prevData];
                timezonedata?.forEach((data) => {
                    const isDuplicate = updatedData?.some((data2) => data?.timezoneName === data2?.timezoneName);
                    if (!isDuplicate) {
                        updatedData?.push(data);
                    }
                });
                return updatedData;
            });

            if (targeted !== "search") setSkip(newStart);
            // if (targeted === "search") setLimit(newLimit);
        } catch (error) {
            console.log("Error in loadMore:", error);
        } finally {
            setLoading(false);
            isFetchingMore.current = false;
        }
    };

    const [loadingMoreData, setLoadingMoreData] = useState(false);

    const onItemsRendered = async (props) => {
        if (props?.overscanStopIndex >= timeZoneData?.length - 1 && !loadingMoreData && searchTerm=="") {
            setLoadingMoreData(true);
            await loadMore(searchTermRef.current ? "search" : "load", searchTermRef.current)
            setLoadingMoreData(false);
        }
    };

    const renderMenu = menu => {
        return (
            <>
                {menu}
                {loading && <FixedLoader />}
            </>
        );
    }

    const FixedLoader = () => (
        <Loader
            content="Loading..."
            style={{
                display: 'flex',
                justifyContent: 'center',
                position: 'absolute',
                bottom: '0',
                background: '#fff',
                width: '100%',
                padding: '4px 0'
            }}
        />
    );

    const [timezoneList, setTimezoneList] = useState([])
    useEffect(() => {
        if (timeZoneData && timeZoneData?.length > 0) {
            let zonelist = timeZoneData?.map((zone) => {
                return {
                    value: zone?.timezoneName,
                    label:
                        zone?.timezoneName +
                        "(" +
                        zone?.timezoneAbbr +
                        zone?.timezone +
                        ")",
                };
            })
            const updatedList = [
                // initialTimezone?.value === optionSelected?.value ? null : initialTimezone,
                ...optionSelected,
                ...zonelist?.filter(
                    (zone) =>
                        // zone?.value !== initialTimezone?.value &&
                        zone?.value !== optionSelected?.value
                ),
            ];

            const uniqueList = Array.from(
                new Map(updatedList?.filter(Boolean)?.map((item) => [item?.value, item]))?.values()
            );
            setTimezoneList(uniqueList);

        }
    }, [timeZoneData])

    const handleTimezoneChange = (value) => {
        const selectedOption = timezoneList?.find((option) => option?.value === value);
        setOptionSelected(selectedOption ? [selectedOption] : null);
        setValue("timeZone", value)
        setTimeZone(value)
        setH(true)
        // if (value != timeZone) {
        //     setShowToast(false)
        //     setToastMsg(t("timeSlotsAreConvertedInYourSelectedTimezone", { defaultValue: "Time slots are converted in your selected timezone." }))
        //     ToasterNotification({
        //         type: "info",
        //         i18keyFormat: "timeSlotsAreConvertedInYourSelectedTimezone",
        //         message: "Time slots are converted in your selected timezone.",
        //         options: { position: "top-right", hideProgressBar: true, autoClose: false, dismiss:true },
        //     })
        // }
    }

    useEffect(()=>{
        if(optionSelected?.length == 0 && timezoneList && timezoneList?.length > 0 ){
            setOptionSelected([timezoneList[0]])
        }
    },[timezoneList, optionSelected])

    return (
      <>
        <Controller
          control={control}
          name="timeZone"
          refs={register("timeZone")}
          render={({ field: { onChange, onBlur, value } }) => (
            <SelectPicker
              data={timezoneList && timezoneList?.length > 0 ? timezoneList : []}
              placement={target === "Availability" ? "bottomStart" : "bottomEnd"}
              menuStyle={{ 
                width: target === "mobileView" ? '90%' : '460px'
            }}
              className={target === "mobileView" ? "w-50" : target === "Availability" ? "w-100" : "w-75"}
            //   value={value !== undefined ? value : initialTimezone?.value}
              value={optionSelected[0]?.value?optionSelected[0]?.value: timezoneList[0]?.value}
              onSearch={handleSearch}
              onChange={handleTimezoneChange}
              cleanable={false}
              virtualized
              renderMenu={renderMenu}
              listProps={{ onItemsRendered }}
              renderMenuItem={(label, item) => (
                <div style={{  
                    display: 'flex',
                    alignItems: 'center',
                    whiteSpace: 'nowrap', }}>{label}</div>
              )}
            />
          )}
        />
      </>
    );
}
